import request from '@/libs/request'

export function setting () {
  return request({
    url: `system/info`,
    method: 'get'
  })
}

export function settingUpdate (data) {
  return request({
    url: `system/updateSetting`,
    method: 'post',
    data
  })
}

export function settingDist () {
  return request({
    url: `system/distInfo`,
    method: 'get'
  })
}
export function settingDistUpdate (data) {
  return request({
    url: `system/updateDistSetting`,
    method: 'post',
    data
  })
}
